import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { useAuth } from '../../../../../context/AuthContext';
import axios from "axios";
import Swal from 'sweetalert2'


export const AdminPackageEdit = () => {
    const params = useParams();
    const [data, setData] = useState([]);
    const { t } = useTranslation()
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token

            }
            let url = "https://api.heryerdeingilizce.com/api/admin/Package/Update";

            await axios({
                method: 'Put',
                url: url,
                data: {
                    id: data.id,
                    isDeleted: false,
                    packageName: document.getElementById("packageName").value,
                    packageDetail: document.getElementById("packageDetail").value,
                    packageFeaturedImage: null,
                    packagePrice: document.getElementById("packagePrice").value,
                    studentLimit: document.getElementById("studentLimit").value,
                    isActive: document.getElementById("isActive").value,
                    howManyDays: document.getElementById("howManyDays").value,
                    isInvidual: document.getElementById("isInvidual").value,
                    isItPrivate: document.getElementById("isItPrivate").value,
                    sortNumber: document.getElementById("sortNumber").value,


                },
                headers: headerss
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Güncellendi!",
                            // text: "You clicked the button!",
                            icon: "success",
                            confirmButtonText: `Tamam`
                        });
                        window.location.reload();
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            setMsg(err);
        }
    }




    useEffect(() => {
        (async () => {
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                let url = "https://api.heryerdeingilizce.com/api/admin/Package/Get";
                await axios({
                    method: 'GET',
                    url: url,
                    params: {
                        id: params["id"]
                    },
                    headers: headerss
                }).then(res => {
                    if (res.status === 200) {

                        if (res.data['success']) {
                            setData(res.data['data']);
                        }
                        else {
                            setMsg(res.data['message']);
                        }
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            } catch (err) {
                setMsg(err);
            }
        })()
    }, [])



    return (
        <div style={{ backgroundColor: "white", padding: "3%" }}>
            <div style={{ textAlign: "center" }}>
                <h1>{t("editPackage")}</h1>
            </div>
            <h4>{msg}</h4>
            <form onSubmit={handleSubmit} >
                <div class="mb-3">
                    <label for="packageName" class="form-label">{t("packageName")}</label>
                    <textarea class="form-control" id="packageName" defaultValue={data.packageName} />
                </div>
                <div class="mb-3">
                    <label for="packageDetail" class="form-label">{t("packageDescription")}</label>
                    <textarea class="form-control" id="packageDetail" defaultValue={data.packageDetail} />
                </div>
                <div class="mb-3">
                    <label for="packagePrice" class="form-label">{t("packagePrice")}</label>
                    <textarea class="form-control" id="packagePrice" defaultValue={data.packagePrice} />
                </div>
                <div class="mb-3">
                    <label for="studentLimit" class="form-label">{t("studentCount")}</label>
                    <textarea class="form-control" id="studentLimit" defaultValue={data.studentLimit} />
                </div>
                <div class="mb-3">
                    <label for="howManyDays" class="form-label">{t("validityDate")}</label>
                    <textarea class="form-control" id="howManyDays" defaultValue={data.howManyDays} />
                </div>

                <div class="mb-3">
                    <label for="sortNumber" class="form-label">{t("sortid")}</label>
                    <textarea class="form-control" id="sortNumber" defaultValue={data.sortNumber} />
                </div>
                <div class="mb-3">
                    <label for="isActive" class="form-label">{t('isActive')}</label>

                    {data.isActive ? (
                        <select id="isActive" class="form-select" required >
                            <option key="1" value="true" selected>{t('active')}</option>
                            <option key="0" value="false" >{t('passive')}</option>
                        </select>

                    ) : (
                        <select id="isActive" class="form-select" required >
                            <option key="0" value="false" selected>{t('passive')}</option>
                            <option key="1" value="true" >{t('active')}</option>
                        </select>
                    )}
                </div>
                <div class="mb-3">
                    <label for="isInvidual" class="form-label">{t('isInvidual')}</label>
                    {data.isInvidual ? (
                        <select id="isInvidual" class="form-select" required >
                            <option key="1" value="true" selected>{t('yes')}</option>
                            <option key="0" value="false" >{t('no')}</option>
                        </select>
                    ) : (
                        <select id="isInvidual" class="form-select" required >
                            <option key="0" value="false" selected>{t('no')}</option>
                            <option key="1" value="true" >{t('yes')}</option>
                        </select>
                    )}
                </div>


                <div class="mb-3">
                    <label for="isItPrivate" class="form-label">{t('isPrivate')}</label>

                    {data.isItPrivate ? (
                        <select id="isItPrivate" class="form-select" required >
                            <option key="1" value="true" selected>{t('yes')}</option>
                            <option key="0" value="false" >{t('no')}</option>
                        </select>

                    ) : (
                        <select id="isItPrivate" class="form-select" required >
                            <option key="0" value="false" selected>{t('no')}</option>
                            <option key="1" value="true" >{t('yes')}</option>
                        </select>
                    )}
                </div>


                <div className='d-flex justify-content-center'>
                    <button type="submit" class="btn btn-primary btn-lg">{t("update")}</button>
                </div>

            </form>
        </div>
    );
};
export default AdminPackageEdit;


